<template>
    <!-- <Html :lang="head.htmlAttrs.lang" :dir="head.htmlAttrs.dir">

  <Head>

    <template v-for="link in head.link" :key="link.id">
      <Link :id="link.id" :rel="link.rel" :href="link.href" :hreflang="link.hreflang" />
    </template>
<template v-for="meta in head.meta" :key="meta.id">
      <Meta :id="meta.id" :property="meta.property" :content="meta.content" />
    </template>
</Head> -->

    <!-- <Body> -->
    <UApp :toaster="{ position: $viewport.isLessThan('md') ? 'bottom-center' : 'top-center' }" :locale="locales[locale as 'fr' | 'en']" class="">
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </UApp>
    <!-- </Body> -->

    <!-- </Html> -->
</template>
<script setup lang="ts">
import { fr, en } from '@nuxt/ui/locale';
const locales = { fr, en };
const { t, locale } = useI18n();

useSeoMeta({
    title: t('titre'),
    applicationName: 'Air&Montagne',
    description: t('description')
});

const localeHead = useLocaleHead({
    dir: true,
    key: 'hid',
    seo: true
});

useHead({
    htmlAttrs: {
        lang: localeHead.value.htmlAttrs!.lang,
        dir: localeHead.value.htmlAttrs!.dir,
        class: 'font-nunito dark:scheme-dark'
    },

    link: [
        ...(localeHead.value.link || []),
        {
            rel: 'preconnect',
            href: 'https://fonts.googleapis.com'
        },
        {
            rel: 'preconnect',
            href: 'https://fonts.gstatic.com',
            crossorigin: 'anonymous'
        },
        {
            rel: 'preload',
            as: 'font',
            crossorigin: 'anonymous',
            href: 'https://fonts.gstatic.com/l/font?kit=RrQfboBx-C5_bxjTw2bF85RtQagYKv-yCW26GEgKS4mxN84A6cFwt7t18Qu22FWEj9rxUhdwLcI-C0OZnNh1brWE_brpTM1Imv6t1BBJjbmK2x4Nd14-lbAehL3lpUg_YcA9htyiDV5l5G1dFoMzOzffxe7ePkYlDcILD1YUnmmGxfFYw4LAM8dA9Yj7sQ4z0lpSq0uJ3itC4bhgaY8OBia7PBXlVWj4SfbIXsClkme_oNtcOiyQUcI9FJQ3FtvX3jBPvRbUZVqlcG73QwmjLkuKp4Uf6wsL9nTkvfxRzF2eYwLPqtAF3KAteYG4nzi9cniKIUAaDNkW7YsrCMpqWxQPnnxm9e07OeY3WjxJn4_QRe7imjiobfXPWk2F41okJ6TsGmgZg_EwoXKwQhgdY1Vi5TrZ59_ncsJmW_HnsJ-SXvT0lWCJUEpz1gws-ceDAMKSOmDXjGL-wQygtlzDzisvY9dGJuK2BsgMfxbwRe8DDIEWltyc-sW6fmEQ9ZFZ4OLh51fABo3phwoWirFaEVbcsNMlSCdKUf1NUEi4i5DBJUTaKEQtY0k27hYxXrr3PlyrLWmX&skey=dcf71eb6104dcefb&v=v25'
        },
        {
            rel: 'preload',
            as: 'font',
            crossorigin: 'anonymous',
            href: 'https://fonts.gstatic.com/s/nunitosans/v15/pe0qMImSLYBIv1o4X1M8cce9I9s.woff2'
        }
    ],

    meta: [...(localeHead.value.meta || [])]
});
</script>
<style></style>
